// Máy chủ (payment-service) lưu giờ UTC nhưng trả chuỗi KHÔNG kèm múi giờ,
// vd "2026-09-23T13:28:42.856528". new Date() sẽ hiểu nhầm đó là giờ máy người dùng
// (lệch 7 tiếng ở VN). Hàm này coi chuỗi thiếu múi giờ là UTC; chuỗi đã có 'Z'
// hoặc +07:00 thì giữ nguyên, nên máy chủ đổi sang trả kèm múi giờ vẫn chạy đúng.
const HAS_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/i;
const HAS_TIME = /T\d{2}:\d{2}/;

export const parseServerDate = (value?: string | null): Date | null => {
  if (!value) return null;
  const s = value.trim();
  const iso = HAS_TIME.test(s) && !HAS_OFFSET.test(s) ? `${s}Z` : s;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** Giờ máy chủ hiển thị theo giờ máy người dùng (vi-VN); chuỗi hỏng thì trả rỗng. */
export const formatServerDateTime = (value?: string | null): string =>
  parseServerDate(value)?.toLocaleString('vi-VN') ?? '';
